import React from "react";

export const valueToGroupOption = function(value: any, options: Array<{value: any; category: string; label: string}>): {value: any; category: string; label: string} {
  let option = options?.find(option => option.value === value)
  if (!option) {
    return options[0];
  } else {
    return option;
  }
}

export const options_industory = [
  { value: 100001, label: 'アートとエンターテインメントその他', },
  { value: 100002, label: '書籍と文学', },
  { value: 100003, label: '芸能/ゴシップ', },
  { value: 100004, label: '美術品', },
  { value: 100005, label: 'ユーモア', },
  { value: 100006, label: '映画', },
  { value: 100007, label: '音楽', },
  { value: 100008, label: 'テレビ', },
  { value: 100009, label: '自動車その他', },
  { value: 100010, label: '自動車部品', },
  { value: 100011, label: '自動車修理', },
  { value: 100012, label: '自動車売買', },
  { value: 100013, label: '自動車カルチャー', },
  { value: 100014, label: '中古車', },
  { value: 100015, label: 'オープンカー', },
  { value: 100016, label: 'クーペ', },
  { value: 100017, label: 'SUV', },
  { value: 100018, label: 'ディーゼル車', },
  { value: 100019, label: '電気自動車', },
  { value: 100020, label: 'ハッチバック車', },
  { value: 100021, label: 'ハイブリッド車', },
  { value: 100022, label: '高級車', },
  { value: 100023, label: 'ニミバン', },
  { value: 100024, label: 'オートバイ', },
  { value: 100025, label: 'オフロード車', },
  { value: 100026, label: '高性能車', },
  { value: 100027, label: '小型トラック', },
  { value: 100028, label: 'けん引車', },
  { value: 100029, label: 'セダン', },
  { value: 100030, label: 'トラックと付属品', },
  { value: 100031, label: 'ヴィンテージカ―', },
  { value: 100032, label: 'ワゴン車', },
  { value: 100033, label: 'ビジネスその他', },
  { value: 100034, label: '広告業', },
  { value: 100035, label: '農業', },
  { value: 100036, label: 'バイオテクノロジー/バイオメディカル', },
  { value: 100037, label: 'ビジネスソフト', },
  { value: 100038, label: '建設業', },
  { value: 100039, label: '林業', },
  { value: 100040, label: '政府', },
  { value: 100041, label: '環境ビジネス', },
  { value: 100042, label: '人材', },
  { value: 100043, label: '物流', },
  { value: 100044, label: 'マーケティング', },
  { value: 100045, label: '金属', },
  { value: 100046, label: 'キャリアその他', },
  { value: 100047, label: 'キャリアプラン', },
  { value: 100048, label: '大学', },
  { value: 100049, label: '経済的援助', },
  { value: 100050, label: '就職説明会', },
  { value: 100051, label: '求人情報', },
  { value: 100052, label: '履歴書の書き方/アドバイス', },
  { value: 100053, label: '看護師', },
  { value: 100054, label: '奨学金', },
  { value: 100055, label: '在宅勤務', },
  { value: 100056, label: '軍人', },
  { value: 100057, label: '職業相談', },
  { value: 100058, label: '教育その他', },
  { value: 100059, label: '中高生の教育', },
  { value: 100060, label: '成人教育', },
  { value: 100061, label: '美術史', },
  { value: 100062, label: '大学管理', },
  { value: 100063, label: '大学生活', },
  { value: 100064, label: '遠隔教育', },
  { value: 100065, label: '第二言語としての英語', },
  { value: 100066, label: '言語学習', },
  { value: 100067, label: '大学院', },
  { value: 100068, label: '自宅学習', },
  { value: 100069, label: '宿題/研究のヒント', },
  { value: 100070, label: '幼稚園/小学生の教育者', },
  { value: 100071, label: '私立学校', },
  { value: 100072, label: '特殊教育', },
  { value: 100073, label: '経営学', },
  { value: 100074, label: '家族と子育てその他', },
  { value: 100075, label: '養子', },
  { value: 100076, label: '赤ちゃんと幼児', },
  { value: 100077, label: '保育園/幼稚園', },
  { value: 100078, label: '家族向けインターネット', },
  { value: 100079, label: '幼稚園/小学生の子育て', },
  { value: 100080, label: '10代の子供の教育', },
  { value: 100081, label: '妊娠', },
  { value: 100082, label: '特別支援教育', },
  { value: 100083, label: '高齢者医療介護', },
  { value: 100084, label: '健康とフィットネスその他', },
  { value: 100085, label: 'エクササイズ', },
  { value: 100086, label: '注意力欠如障害', },
  { value: 100087, label: '後天性免疫不全症候群', },
  { value: 100088, label: 'アレルギー', },
  { value: 100089, label: '代替医療', },
  { value: 100090, label: '関節炎', },
  { value: 100091, label: 'ぜんそく', },
  { value: 100092, label: '関節炎/広汎性発達障害', },
  { value: 100093, label: '双極性障害', },
  { value: 100094, label: '脳腫瘍', },
  { value: 100095, label: '癌', },
  { value: 100096, label: 'コレステロール', },
  { value: 100097, label: '慢性疲労症候群', },
  { value: 100098, label: '慢性の痛み', },
  { value: 100099, label: '風邪とインフルエンザ', },
  { value: 100100, label: '難聴', },
  { value: 100101, label: '歯の手入れ', },
  { value: 100102, label: 'うつ病', },
  { value: 100103, label: '皮膚科', },
  { value: 100104, label: '糖尿病', },
  { value: 100105, label: 'てんかん', },
  { value: 100106, label: '胃食道逆流症/酸逆流', },
  { value: 100107, label: '頭痛/偏頭痛', },
  { value: 100108, label: '心臓病', },
  { value: 100109, label: '健康のためのハーブ', },
  { value: 100110, label: 'ホリスティックヒーリング', },
  { value: 100111, label: 'ポンド/クローン、病', },
  { value: 100112, label: '近親相姦/悪用サポート', },
  { value: 100113, label: '失禁', },
  { value: 100114, label: '不妊', },
  { value: 100115, label: '男性の健康', },
  { value: 100116, label: '栄養', },
  { value: 100117, label: '整形外科', },
  { value: 100118, label: 'パニック/不安障害', },
  { value: 100119, label: '小児科', },
  { value: 100120, label: '理学療法', },
  { value: 100121, label: '心理学/精神医学', },
  { value: 100122, label: 'シニアヘルス', },
  { value: 100123, label: '性的関心', },
  { value: 100124, label: '睡眠障害', },
  { value: 100125, label: '禁煙', },
  { value: 100126, label: '薬物乱用', },
  { value: 100127, label: '甲状腺疾患', },
  { value: 100128, label: '拒食症', },
  { value: 100129, label: '女性の健康', },
  { value: 100130, label: 'フードとドリンクその他', },
  { value: 100131, label: 'アメリカ料理', },
  { value: 100132, label: 'バーベキューとグリル', },
  { value: 100133, label: 'ケイジャン/クレオール', },
  { value: 100134, label: '中国料理', },
  { value: 100135, label: 'カクテル/ビール', },
  { value: 100136, label: 'コーヒー/お茶', },
  { value: 100137, label: '料理', },
  { value: 100138, label: 'デザートとお菓子づくり', },
  { value: 100139, label: '外食', },
  { value: 100140, label: '食物アレルギー', },
  { value: 100141, label: 'フランス料理', },
  { value: 100142, label: '健康/低脂肪クッキング', },
  { value: 100143, label: 'イタリア料理', },
  { value: 100144, label: '日本料理', },
  { value: 100145, label: 'メキシコ料理', },
  { value: 100146, label: '菜食主義', },
  { value: 100147, label: 'ベジタリアン', },
  { value: 100148, label: 'ワイン', },
  { value: 100149, label: '趣味と興味その他', },
  { value: 100150, label: 'アート/テクノロジー', },
  { value: 100151, label: '芸術と工芸', },
  { value: 100152, label: 'ビース細工', },
  { value: 100153, label: 'バードウォッチング', },
  { value: 100154, label: 'ビーズゲーム/パズル', },
  { value: 100155, label: 'キャンドルと石鹸作り', },
  { value: 100156, label: 'カードゲーム', },
  { value: 100157, label: 'チェス', },
  { value: 100158, label: '葉巻', },
  { value: 100159, label: '収集', },
  { value: 100160, label: 'コミック', },
  { value: 100161, label: '描画/スケッチ', },
  { value: 100162, label: 'フリーランスのライティング', },
  { value: 100163, label: '系譜', },
  { value: 100164, label: '出版', },
  { value: 100165, label: 'ギター', },
  { value: 100166, label: '自宅でレコーディング', },
  { value: 100167, label: '投資家と特許', },
  { value: 100168, label: '宝飾品', },
  { value: 100169, label: 'マジックとイリュージョン', },
  { value: 100170, label: '裁縫', },
  { value: 100171, label: '絵画', },
  { value: 100172, label: '写真', },
  { value: 100173, label: 'ラジオ', },
  { value: 100174, label: 'ロールプレイングゲーム', },
  { value: 100175, label: 'SFとファンタジー', },
  { value: 100176, label: 'スクラップブック作り', },
  { value: 100177, label: '脚本', },
  { value: 100178, label: 'スタンプとコイン', },
  { value: 100179, label: 'ビデオとコンピュータゲーム', },
  { value: 100180, label: '木工', },
  { value: 100181, label: '家とガーデンその他', },
  { value: 100182, label: '家電製品', },
  { value: 100183, label: '庭いじり', },
  { value: 100184, label: '環境安全', },
  { value: 100185, label: 'ガーデニング', },
  { value: 100186, label: '家の修理', },
  { value: 100187, label: 'ホームシアター', },
  { value: 100188, label: '内装', },
  { value: 100189, label: '造園', },
  { value: 100190, label: 'リフォームと建設', },
  { value: 100191, label: '法律と政治その他', },
  { value: 100192, label: '移民', },
  { value: 100193, label: '法的問題', },
  { value: 100194, label: '資源', },
  { value: 100195, label: '政治', },
  { value: 100196, label: '解説', },
  { value: 100197, label: 'ニュースその他', },
  { value: 100198, label: '国際ニュース', },
  { value: 100199, label: '国内ニュース', },
  { value: 100200, label: 'ローカルニュース', },
  { value: 100201, label: '金融その他', },
  { value: 100202, label: '初心者向けの投資', },
  { value: 100203, label: 'クレジット/債務とローン', },
  { value: 100204, label: '金融ニュース', },
  { value: 100205, label: '財務計画', },
  { value: 100206, label: 'ヘッジファンド', },
  { value: 100207, label: '保険', },
  { value: 100208, label: '投資', },
  { value: 100209, label: '投資信託', },
  { value: 100210, label: 'オプション取引', },
  { value: 100211, label: '退職後の計画', },
  { value: 100212, label: 'ストック', },
  { value: 100213, label: '税務計画', },
  { value: 100214, label: '社会その他', },
  { value: 100215, label: 'デート', },
  { value: 100216, label: '離婚サポート', },
  { value: 100217, label: '同性愛', },
  { value: 100218, label: '結婚', },
  { value: 100219, label: '高齢者', },
  { value: 100220, label: '十代の若者たち', },
  { value: 100221, label: 'ウェディング', },
  { value: 100222, label: '特定の民族', },
  { value: 100223, label: '科学その他', },
  { value: 100224, label: '占星術', },
  { value: 100225, label: '生物学', },
  { value: 100226, label: '化学', },
  { value: 100227, label: '地質', },
  { value: 100228, label: '超常的現象', },
  { value: 100229, label: '物理学', },
  { value: 100230, label: '宇宙/天文', },
  { value: 100231, label: '地理', },
  { value: 100232, label: '植物学', },
  { value: 100233, label: '天候', },
  { value: 100234, label: 'ペットその他', },
  { value: 100235, label: '水族館', },
  { value: 100236, label: '鳥', },
  { value: 100237, label: '猫', },
  { value: 100238, label: '犬', },
  { value: 100239, label: '大型の動物', },
  { value: 100240, label: '爬虫類', },
  { value: 100241, label: '獣医学', },
  { value: 100242, label: 'スポーツその他', },
  { value: 100243, label: '自動車レース', },
  { value: 100244, label: '野球', },
  { value: 100245, label: '自転車', },
  { value: 100246, label: 'ボディービル', },
  { value: 100247, label: 'ボクシング', },
  { value: 100248, label: 'カヌー/カヤック', },
  { value: 100249, label: 'チアリーディング', },
  { value: 100250, label: 'クライミング', },
  { value: 100251, label: 'クリケット', },
  { value: 100252, label: 'フィギュアスケート', },
  { value: 100253, label: 'フライフィッシング', },
  { value: 100254, label: 'サッカー', },
  { value: 100255, label: '淡水釣り', },
  { value: 100256, label: 'ゲームとフィッシュ', },
  { value: 100257, label: 'ゴルフ', },
  { value: 100258, label: '競馬', },
  { value: 100259, label: '馬', },
  { value: 100260, label: 'ハンティング/射撃', },
  { value: 100261, label: 'インラインスケート', },
  { value: 100262, label: '武道', },
  { value: 100263, label: 'マウンテンバイキング', },
  { value: 100264, label: 'ナスカー', },
  { value: 100265, label: '五輪', },
  { value: 100266, label: 'ペイントボール', },
  { value: 100267, label: 'パワーとバイク', },
  { value: 100268, label: 'プロバスケットボール', },
  { value: 100269, label: 'プロアイスホッケー', },
  { value: 100270, label: 'ロデオ', },
  { value: 100271, label: 'ラグビー', },
  { value: 100272, label: 'ジョギング/ランニング', },
  { value: 100273, label: 'セーリング', },
  { value: 100274, label: '海釣り', },
  { value: 100275, label: 'スキューバダイビング', },
  { value: 100276, label: 'スケートボード', },
  { value: 100277, label: 'スキー', },
  { value: 100278, label: 'スノーボード', },
  { value: 100279, label: 'サーフィン/ボディーボード', },
  { value: 100280, label: '水泳', },
  { value: 100281, label: '卓球/ピンポン', },
  { value: 100282, label: 'テニス', },
  { value: 100283, label: 'バレーボール', },
  { value: 100284, label: 'ウォーキング', },
  { value: 100285, label: 'ウォータースキー/ウェイクボード', },
  { value: 100286, label: 'ワールドサッカー', },
  { value: 100287, label: 'スタイルとファッションその他', },
  { value: 100288, label: '美', },
  { value: 100289, label: 'ボディーアート', },
  { value: 100290, label: 'ファッション', },
  { value: 100291, label: 'ジュエリー', },
  { value: 100292, label: '衣類', },
  { value: 100293, label: 'アクセサリー', },
  { value: 100294, label: 'テクノロジーとコンピュータその他', },
  { value: 100295, label: '3-Dグラフィックス', },
  { value: 100296, label: 'アニメーション', },
  { value: 100297, label: 'ウイルス対策', },
  { value: 100298, label: 'C/C++', },
  { value: 100299, label: 'カメラとビデオカメラ', },
  { value: 100300, label: '携帯電話', },
  { value: 100301, label: 'コンピュータ資格', },
  { value: 100302, label: 'コンピューターネットワーク', },
  { value: 100303, label: 'コンピューター周辺機器', },
  { value: 100304, label: 'コンピュータのレビュー', },
  { value: 100305, label: 'データセンター', },
  { value: 100306, label: 'データベース', },
  { value: 100307, label: 'デスクトップパブリッシング', },
  { value: 100308, label: 'デスクトップビデオ', },
  { value: 100309, label: 'メール', },
  { value: 100310, label: 'グラフィックスソフトウェア', },
  { value: 100311, label: 'ホームビデオ/DVD', },
  { value: 100312, label: 'インターネット技術', },
  { value: 100313, label: 'Java', },
  { value: 100314, label: 'JavaScript', },
  { value: 100315, label: 'マックのサポート', },
  { value: 100316, label: 'MP3/MIDI', },
  { value: 100317, label: 'ネット会議', },
  { value: 100318, label: '初心者のためのネット', },
  { value: 100319, label: 'ネットワークセキュリティー', },
  { value: 100320, label: 'パームトップ/携帯情報端末', },
  { value: 100321, label: 'PCサポート', },
  { value: 100322, label: 'ポータブル', },
  { value: 100323, label: 'エンターテインメント', },
  { value: 100324, label: 'フリーウェア/シェアウェア', },
  { value: 100325, label: 'Unix', },
  { value: 100326, label: 'ビジュアルベーシック', },
  { value: 100327, label: 'Webのクリップアート', },
  { value: 100328, label: 'ウェブデザイン/HTML', },
  { value: 100329, label: 'ウェブ検索', },
  { value: 100330, label: 'ウィンドウズ', },
  { value: 100331, label: '旅行その他', },
  { value: 100332, label: '冒険旅行', },
  { value: 100333, label: 'アフリカ', },
  { value: 100334, label: '航空旅行', },
  { value: 100335, label: 'オーストラリアとニュージーランド', },
  { value: 100336, label: 'ベッドと朝食', },
  { value: 100337, label: 'バジェット・トラベル', },
  { value: 100338, label: '出張旅行', },
  { value: 100339, label: '米国のロケールによって', },
  { value: 100340, label: 'キャンプ', },
  { value: 100341, label: 'カナダ', },
  { value: 100342, label: 'カリブ海', },
  { value: 100343, label: 'クルーズ', },
  { value: 100344, label: '東欧', },
  { value: 100345, label: 'ヨーロッパ', },
  { value: 100346, label: 'フランス', },
  { value: 100347, label: 'ギリシャ', },
  { value: 100348, label: 'ハネムーン/休暇', },
  { value: 100349, label: 'ホテル', },
  { value: 100350, label: 'イタリア', },
  { value: 100351, label: '日本', },
  { value: 100352, label: 'メキシコと中米', },
  { value: 100353, label: '国立公園', },
  { value: 100354, label: '南米', },
  { value: 100355, label: 'スパ', },
  { value: 100356, label: 'テーマパーク', },
  { value: 100357, label: '子供と一緒に旅行', },
  { value: 100358, label: 'イギリス', },
  { value: 100359, label: '不動産その他', },
  { value: 100360, label: 'アパート', },
  { value: 100361, label: '建築家', },
  { value: 100362, label: '家の売買', },
  { value: 100363, label: 'ショッピングその他', },
  { value: 100364, label: 'コンテストと景品', },
  { value: 100365, label: 'クーポン', },
  { value: 100366, label: '比較', },
  { value: 100367, label: 'エンジン', },
  { value: 100368, label: '宗教とスピリチュアルその他', },
  { value: 100369, label: '代替宗教', },
  { value: 100370, label: '無神論/不可知論', },
  { value: 100371, label: '仏教', },
  { value: 100372, label: 'カトリック', },
  { value: 100373, label: 'キリスト教', },
  { value: 100374, label: 'ヒンドゥー教', },
  { value: 100375, label: 'イスラム教', },
  { value: 100376, label: 'ユダヤ教', },
  { value: 100377, label: '末日聖徒', },
  { value: 100378, label: '異教徒/ウィッカ信者', },
  { value: 100379, label: 'カテゴリ不明その他', },
  { value: 100380, label: '非標準のコンテンツその他', },
  { value: 100381, label: '野良コンテンツ', },
  { value: 100382, label: '極端な表現/露骨な暴力', },
  { value: 100383, label: 'アダルト', },
  { value: 100384, label: '卑猥なコンテンツ', },
  { value: 100385, label: '悪意のあるコンテンツ', },
  { value: 100386, label: '準備中のサイト', },
  { value: 100387, label: 'インセンティブ広告', },
  { value: 100388, label: '違法コンテンツその他', },
  { value: 100389, label: '違法コンテンツ', },
  { value: 100390, label: '非合法ソフト', },
  { value: 100391, label: 'スパイウェア/マルウェア', },
  { value: 100392, label: '著作権侵害', },
];

export const options_group_industory = [
  { value: 100001, category: 'アートとエンターテインメント', label: 'アートとエンターテインメントその他', },
  { value: 100002, category: 'アートとエンターテインメント', label: '書籍と文学', },
  { value: 100003, category: 'アートとエンターテインメント', label: '芸能/ゴシップ', },
  { value: 100004, category: 'アートとエンターテインメント', label: '美術品', },
  { value: 100005, category: 'アートとエンターテインメント', label: 'ユーモア', },
  { value: 100006, category: 'アートとエンターテインメント', label: '映画', },
  { value: 100007, category: 'アートとエンターテインメント', label: '音楽', },
  { value: 100008, category: 'アートとエンターテインメント', label: 'テレビ', },
  { value: 100009, category: '自動車', label: '自動車その他', },
  { value: 100010, category: '自動車', label: '自動車部品', },
  { value: 100011, category: '自動車', label: '自動車修理', },
  { value: 100012, category: '自動車', label: '自動車売買', },
  { value: 100013, category: '自動車', label: '自動車カルチャー', },
  { value: 100014, category: '自動車', label: '中古車', },
  { value: 100015, category: '自動車', label: 'オープンカー', },
  { value: 100016, category: '自動車', label: 'クーペ', },
  { value: 100017, category: '自動車', label: 'SUV', },
  { value: 100018, category: '自動車', label: 'ディーゼル車', },
  { value: 100019, category: '自動車', label: '電気自動車', },
  { value: 100020, category: '自動車', label: 'ハッチバック車', },
  { value: 100021, category: '自動車', label: 'ハイブリッド車', },
  { value: 100022, category: '自動車', label: '高級車', },
  { value: 100023, category: '自動車', label: 'ニミバン', },
  { value: 100024, category: '自動車', label: 'オートバイ', },
  { value: 100025, category: '自動車', label: 'オフロード車', },
  { value: 100026, category: '自動車', label: '高性能車', },
  { value: 100027, category: '自動車', label: '小型トラック', },
  { value: 100028, category: '自動車', label: 'けん引車', },
  { value: 100029, category: '自動車', label: 'セダン', },
  { value: 100030, category: '自動車', label: 'トラックと付属品', },
  { value: 100031, category: '自動車', label: 'ヴィンテージカ―', },
  { value: 100032, category: '自動車', label: 'ワゴン車', },
  { value: 100033, category: 'ビジネス', label: 'ビジネスその他', },
  { value: 100034, category: 'ビジネス', label: '広告業', },
  { value: 100035, category: 'ビジネス', label: '農業', },
  { value: 100036, category: 'ビジネス', label: 'バイオテクノロジー/バイオメディカル', },
  { value: 100037, category: 'ビジネス', label: 'ビジネスソフト', },
  { value: 100038, category: 'ビジネス', label: '建設業', },
  { value: 100039, category: 'ビジネス', label: '林業', },
  { value: 100040, category: 'ビジネス', label: '政府', },
  { value: 100041, category: 'ビジネス', label: '環境ビジネス', },
  { value: 100042, category: 'ビジネス', label: '人材', },
  { value: 100043, category: 'ビジネス', label: '物流', },
  { value: 100044, category: 'ビジネス', label: 'マーケティング', },
  { value: 100045, category: 'ビジネス', label: '金属', },
  { value: 100046, category: 'キャリア', label: 'キャリアその他', },
  { value: 100047, category: 'キャリア', label: 'キャリアプラン', },
  { value: 100048, category: 'キャリア', label: '大学', },
  { value: 100049, category: 'キャリア', label: '経済的援助', },
  { value: 100050, category: 'キャリア', label: '就職説明会', },
  { value: 100051, category: 'キャリア', label: '求人情報', },
  { value: 100052, category: 'キャリア', label: '履歴書の書き方/アドバイス', },
  { value: 100053, category: 'キャリア', label: '看護師', },
  { value: 100054, category: 'キャリア', label: '奨学金', },
  { value: 100055, category: 'キャリア', label: '在宅勤務', },
  { value: 100056, category: 'キャリア', label: '軍人', },
  { value: 100057, category: 'キャリア', label: '職業相談', },
  { value: 100058, category: '教育', label: '教育その他', },
  { value: 100059, category: '教育', label: '中高生の教育', },
  { value: 100060, category: '教育', label: '成人教育', },
  { value: 100061, category: '教育', label: '美術史', },
  { value: 100062, category: '教育', label: '大学管理', },
  { value: 100063, category: '教育', label: '大学生活', },
  { value: 100064, category: '教育', label: '遠隔教育', },
  { value: 100065, category: '教育', label: '第二言語としての英語', },
  { value: 100066, category: '教育', label: '言語学習', },
  { value: 100067, category: '教育', label: '大学院', },
  { value: 100068, category: '教育', label: '自宅学習', },
  { value: 100069, category: '教育', label: '宿題/研究のヒント', },
  { value: 100070, category: '教育', label: '幼稚園/小学生の教育者', },
  { value: 100071, category: '教育', label: '私立学校', },
  { value: 100072, category: '教育', label: '特殊教育', },
  { value: 100073, category: '教育', label: '経営学', },
  { value: 100074, category: '家族と子育て', label: '家族と子育てその他', },
  { value: 100075, category: '家族と子育て', label: '養子', },
  { value: 100076, category: '家族と子育て', label: '赤ちゃんと幼児', },
  { value: 100077, category: '家族と子育て', label: '保育園/幼稚園', },
  { value: 100078, category: '家族と子育て', label: '家族向けインターネット', },
  { value: 100079, category: '家族と子育て', label: '幼稚園/小学生の子育て', },
  { value: 100080, category: '家族と子育て', label: '10代の子供の教育', },
  { value: 100081, category: '家族と子育て', label: '妊娠', },
  { value: 100082, category: '家族と子育て', label: '特別支援教育', },
  { value: 100083, category: '家族と子育て', label: '高齢者医療介護', },
  { value: 100084, category: '健康とフィットネス', label: '健康とフィットネスその他', },
  { value: 100085, category: '健康とフィットネス', label: 'エクササイズ', },
  { value: 100086, category: '健康とフィットネス', label: '注意力欠如障害', },
  { value: 100087, category: '健康とフィットネス', label: '後天性免疫不全症候群', },
  { value: 100088, category: '健康とフィットネス', label: 'アレルギー', },
  { value: 100089, category: '健康とフィットネス', label: '代替医療', },
  { value: 100090, category: '健康とフィットネス', label: '関節炎', },
  { value: 100091, category: '健康とフィットネス', label: 'ぜんそく', },
  { value: 100092, category: '健康とフィットネス', label: '関節炎/広汎性発達障害', },
  { value: 100093, category: '健康とフィットネス', label: '双極性障害', },
  { value: 100094, category: '健康とフィットネス', label: '脳腫瘍', },
  { value: 100095, category: '健康とフィットネス', label: '癌', },
  { value: 100096, category: '健康とフィットネス', label: 'コレステロール', },
  { value: 100097, category: '健康とフィットネス', label: '慢性疲労症候群', },
  { value: 100098, category: '健康とフィットネス', label: '慢性の痛み', },
  { value: 100099, category: '健康とフィットネス', label: '風邪とインフルエンザ', },
  { value: 100100, category: '健康とフィットネス', label: '難聴', },
  { value: 100101, category: '健康とフィットネス', label: '歯の手入れ', },
  { value: 100102, category: '健康とフィットネス', label: 'うつ病', },
  { value: 100103, category: '健康とフィットネス', label: '皮膚科', },
  { value: 100104, category: '健康とフィットネス', label: '糖尿病', },
  { value: 100105, category: '健康とフィットネス', label: 'てんかん', },
  { value: 100106, category: '健康とフィットネス', label: '胃食道逆流症/酸逆流', },
  { value: 100107, category: '健康とフィットネス', label: '頭痛/偏頭痛', },
  { value: 100108, category: '健康とフィットネス', label: '心臓病', },
  { value: 100109, category: '健康とフィットネス', label: '健康のためのハーブ', },
  { value: 100110, category: '健康とフィットネス', label: 'ホリスティックヒーリング', },
  { value: 100111, category: '健康とフィットネス', label: 'ポンド/クローン、病', },
  { value: 100112, category: '健康とフィットネス', label: '近親相姦/悪用サポート', },
  { value: 100113, category: '健康とフィットネス', label: '失禁', },
  { value: 100114, category: '健康とフィットネス', label: '不妊', },
  { value: 100115, category: '健康とフィットネス', label: '男性の健康', },
  { value: 100116, category: '健康とフィットネス', label: '栄養', },
  { value: 100117, category: '健康とフィットネス', label: '整形外科', },
  { value: 100118, category: '健康とフィットネス', label: 'パニック/不安障害', },
  { value: 100119, category: '健康とフィットネス', label: '小児科', },
  { value: 100120, category: '健康とフィットネス', label: '理学療法', },
  { value: 100121, category: '健康とフィットネス', label: '心理学/精神医学', },
  { value: 100122, category: '健康とフィットネス', label: 'シニアヘルス', },
  { value: 100123, category: '健康とフィットネス', label: '性的関心', },
  { value: 100124, category: '健康とフィットネス', label: '睡眠障害', },
  { value: 100125, category: '健康とフィットネス', label: '禁煙', },
  { value: 100126, category: '健康とフィットネス', label: '薬物乱用', },
  { value: 100127, category: '健康とフィットネス', label: '甲状腺疾患', },
  { value: 100128, category: '健康とフィットネス', label: '拒食症', },
  { value: 100129, category: '健康とフィットネス', label: '女性の健康', },
  { value: 100130, category: 'フードとドリンク', label: 'フードとドリンクその他', },
  { value: 100131, category: 'フードとドリンク', label: 'アメリカ料理', },
  { value: 100132, category: 'フードとドリンク', label: 'バーベキューとグリル', },
  { value: 100133, category: 'フードとドリンク', label: 'ケイジャン/クレオール', },
  { value: 100134, category: 'フードとドリンク', label: '中国料理', },
  { value: 100135, category: 'フードとドリンク', label: 'カクテル/ビール', },
  { value: 100136, category: 'フードとドリンク', label: 'コーヒー/お茶', },
  { value: 100137, category: 'フードとドリンク', label: '料理', },
  { value: 100138, category: 'フードとドリンク', label: 'デザートとお菓子づくり', },
  { value: 100139, category: 'フードとドリンク', label: '外食', },
  { value: 100140, category: 'フードとドリンク', label: '食物アレルギー', },
  { value: 100141, category: 'フードとドリンク', label: 'フランス料理', },
  { value: 100142, category: 'フードとドリンク', label: '健康/低脂肪クッキング', },
  { value: 100143, category: 'フードとドリンク', label: 'イタリア料理', },
  { value: 100144, category: 'フードとドリンク', label: '日本料理', },
  { value: 100145, category: 'フードとドリンク', label: 'メキシコ料理', },
  { value: 100146, category: 'フードとドリンク', label: '菜食主義', },
  { value: 100147, category: 'フードとドリンク', label: 'ベジタリアン', },
  { value: 100148, category: 'フードとドリンク', label: 'ワイン', },
  { value: 100149, category: '趣味と興味', label: '趣味と興味その他', },
  { value: 100150, category: '趣味と興味', label: 'アート/テクノロジー', },
  { value: 100151, category: '趣味と興味', label: '芸術と工芸', },
  { value: 100152, category: '趣味と興味', label: 'ビース細工', },
  { value: 100153, category: '趣味と興味', label: 'バードウォッチング', },
  { value: 100154, category: '趣味と興味', label: 'ビーズゲーム/パズル', },
  { value: 100155, category: '趣味と興味', label: 'キャンドルと石鹸作り', },
  { value: 100156, category: '趣味と興味', label: 'カードゲーム', },
  { value: 100157, category: '趣味と興味', label: 'チェス', },
  { value: 100158, category: '趣味と興味', label: '葉巻', },
  { value: 100159, category: '趣味と興味', label: '収集', },
  { value: 100160, category: '趣味と興味', label: 'コミック', },
  { value: 100161, category: '趣味と興味', label: '描画/スケッチ', },
  { value: 100162, category: '趣味と興味', label: 'フリーランスのライティング', },
  { value: 100163, category: '趣味と興味', label: '系譜', },
  { value: 100164, category: '趣味と興味', label: '出版', },
  { value: 100165, category: '趣味と興味', label: 'ギター', },
  { value: 100166, category: '趣味と興味', label: '自宅でレコーディング', },
  { value: 100167, category: '趣味と興味', label: '投資家と特許', },
  { value: 100168, category: '趣味と興味', label: '宝飾品', },
  { value: 100169, category: '趣味と興味', label: 'マジックとイリュージョン', },
  { value: 100170, category: '趣味と興味', label: '裁縫', },
  { value: 100171, category: '趣味と興味', label: '絵画', },
  { value: 100172, category: '趣味と興味', label: '写真', },
  { value: 100173, category: '趣味と興味', label: 'ラジオ', },
  { value: 100174, category: '趣味と興味', label: 'ロールプレイングゲーム', },
  { value: 100175, category: '趣味と興味', label: 'SFとファンタジー', },
  { value: 100176, category: '趣味と興味', label: 'スクラップブック作り', },
  { value: 100177, category: '趣味と興味', label: '脚本', },
  { value: 100178, category: '趣味と興味', label: 'スタンプとコイン', },
  { value: 100179, category: '趣味と興味', label: 'ビデオとコンピュータゲーム', },
  { value: 100180, category: '趣味と興味', label: '木工', },
  { value: 100181, category: '家とガーデン', label: '家とガーデンその他', },
  { value: 100182, category: '家とガーデン', label: '家電製品', },
  { value: 100183, category: '家とガーデン', label: '庭いじり', },
  { value: 100184, category: '家とガーデン', label: '環境安全', },
  { value: 100185, category: '家とガーデン', label: 'ガーデニング', },
  { value: 100186, category: '家とガーデン', label: '家の修理', },
  { value: 100187, category: '家とガーデン', label: 'ホームシアター', },
  { value: 100188, category: '家とガーデン', label: '内装', },
  { value: 100189, category: '家とガーデン', label: '造園', },
  { value: 100190, category: '家とガーデン', label: 'リフォームと建設', },
  { value: 100191, category: '法律と政治', label: '法律と政治その他', },
  { value: 100192, category: '法律と政治', label: '移民', },
  { value: 100193, category: '法律と政治', label: '法的問題', },
  { value: 100194, category: '法律と政治', label: '資源', },
  { value: 100195, category: '法律と政治', label: '政治', },
  { value: 100196, category: '法律と政治', label: '解説', },
  { value: 100197, category: 'ニュース', label: 'ニュースその他', },
  { value: 100198, category: 'ニュース', label: '国際ニュース', },
  { value: 100199, category: 'ニュース', label: '国内ニュース', },
  { value: 100200, category: 'ニュース', label: 'ローカルニュース', },
  { value: 100201, category: '金融', label: '金融その他', },
  { value: 100202, category: '金融', label: '初心者向けの投資', },
  { value: 100203, category: '金融', label: 'クレジット/債務とローン', },
  { value: 100204, category: '金融', label: '金融ニュース', },
  { value: 100205, category: '金融', label: '財務計画', },
  { value: 100206, category: '金融', label: 'ヘッジファンド', },
  { value: 100207, category: '金融', label: '保険', },
  { value: 100208, category: '金融', label: '投資', },
  { value: 100209, category: '金融', label: '投資信託', },
  { value: 100210, category: '金融', label: 'オプション取引', },
  { value: 100211, category: '金融', label: '退職後の計画', },
  { value: 100212, category: '金融', label: 'ストック', },
  { value: 100213, category: '金融', label: '税務計画', },
  { value: 100214, category: '社会', label: '社会その他', },
  { value: 100215, category: '社会', label: 'デート', },
  { value: 100216, category: '社会', label: '離婚サポート', },
  { value: 100217, category: '社会', label: '同性愛', },
  { value: 100218, category: '社会', label: '結婚', },
  { value: 100219, category: '社会', label: '高齢者', },
  { value: 100220, category: '社会', label: '十代の若者たち', },
  { value: 100221, category: '社会', label: 'ウェディング', },
  { value: 100222, category: '社会', label: '特定の民族', },
  { value: 100223, category: '科学', label: '科学その他', },
  { value: 100224, category: '科学', label: '占星術', },
  { value: 100225, category: '科学', label: '生物学', },
  { value: 100226, category: '科学', label: '化学', },
  { value: 100227, category: '科学', label: '地質', },
  { value: 100228, category: '科学', label: '超常的現象', },
  { value: 100229, category: '科学', label: '物理学', },
  { value: 100230, category: '科学', label: '宇宙/天文', },
  { value: 100231, category: '科学', label: '地理', },
  { value: 100232, category: '科学', label: '植物学', },
  { value: 100233, category: '科学', label: '天候', },
  { value: 100234, category: 'ペット', label: 'ペットその他', },
  { value: 100235, category: 'ペット', label: '水族館', },
  { value: 100236, category: 'ペット', label: '鳥', },
  { value: 100237, category: 'ペット', label: '猫', },
  { value: 100238, category: 'ペット', label: '犬', },
  { value: 100239, category: 'ペット', label: '大型の動物', },
  { value: 100240, category: 'ペット', label: '爬虫類', },
  { value: 100241, category: 'ペット', label: '獣医学', },
  { value: 100242, category: 'スポーツ', label: 'スポーツその他', },
  { value: 100243, category: 'スポーツ', label: '自動車レース', },
  { value: 100244, category: 'スポーツ', label: '野球', },
  { value: 100245, category: 'スポーツ', label: '自転車', },
  { value: 100246, category: 'スポーツ', label: 'ボディービル', },
  { value: 100247, category: 'スポーツ', label: 'ボクシング', },
  { value: 100248, category: 'スポーツ', label: 'カヌー/カヤック', },
  { value: 100249, category: 'スポーツ', label: 'チアリーディング', },
  { value: 100250, category: 'スポーツ', label: 'クライミング', },
  { value: 100251, category: 'スポーツ', label: 'クリケット', },
  { value: 100252, category: 'スポーツ', label: 'フィギュアスケート', },
  { value: 100253, category: 'スポーツ', label: 'フライフィッシング', },
  { value: 100254, category: 'スポーツ', label: 'サッカー', },
  { value: 100255, category: 'スポーツ', label: '淡水釣り', },
  { value: 100256, category: 'スポーツ', label: 'ゲームとフィッシュ', },
  { value: 100257, category: 'スポーツ', label: 'ゴルフ', },
  { value: 100258, category: 'スポーツ', label: '競馬', },
  { value: 100259, category: 'スポーツ', label: '馬', },
  { value: 100260, category: 'スポーツ', label: 'ハンティング/射撃', },
  { value: 100261, category: 'スポーツ', label: 'インラインスケート', },
  { value: 100262, category: 'スポーツ', label: '武道', },
  { value: 100263, category: 'スポーツ', label: 'マウンテンバイキング', },
  { value: 100264, category: 'スポーツ', label: 'ナスカー', },
  { value: 100265, category: 'スポーツ', label: '五輪', },
  { value: 100266, category: 'スポーツ', label: 'ペイントボール', },
  { value: 100267, category: 'スポーツ', label: 'パワーとバイク', },
  { value: 100268, category: 'スポーツ', label: 'プロバスケットボール', },
  { value: 100269, category: 'スポーツ', label: 'プロアイスホッケー', },
  { value: 100270, category: 'スポーツ', label: 'ロデオ', },
  { value: 100271, category: 'スポーツ', label: 'ラグビー', },
  { value: 100272, category: 'スポーツ', label: 'ジョギング/ランニング', },
  { value: 100273, category: 'スポーツ', label: 'セーリング', },
  { value: 100274, category: 'スポーツ', label: '海釣り', },
  { value: 100275, category: 'スポーツ', label: 'スキューバダイビング', },
  { value: 100276, category: 'スポーツ', label: 'スケートボード', },
  { value: 100277, category: 'スポーツ', label: 'スキー', },
  { value: 100278, category: 'スポーツ', label: 'スノーボード', },
  { value: 100279, category: 'スポーツ', label: 'サーフィン/ボディーボード', },
  { value: 100280, category: 'スポーツ', label: '水泳', },
  { value: 100281, category: 'スポーツ', label: '卓球/ピンポン', },
  { value: 100282, category: 'スポーツ', label: 'テニス', },
  { value: 100283, category: 'スポーツ', label: 'バレーボール', },
  { value: 100284, category: 'スポーツ', label: 'ウォーキング', },
  { value: 100285, category: 'スポーツ', label: 'ウォータースキー/ウェイクボード', },
  { value: 100286, category: 'スポーツ', label: 'ワールドサッカー', },
  { value: 100287, category: 'スタイルとファッション', label: 'スタイルとファッションその他', },
  { value: 100288, category: 'スタイルとファッション', label: '美', },
  { value: 100289, category: 'スタイルとファッション', label: 'ボディーアート', },
  { value: 100290, category: 'スタイルとファッション', label: 'ファッション', },
  { value: 100291, category: 'スタイルとファッション', label: 'ジュエリー', },
  { value: 100292, category: 'スタイルとファッション', label: '衣類', },
  { value: 100293, category: 'スタイルとファッション', label: 'アクセサリー', },
  { value: 100294, category: 'テクノロジーとコンピュータ', label: 'テクノロジーとコンピュータその他', },
  { value: 100295, category: 'テクノロジーとコンピュータ', label: '3-Dグラフィックス', },
  { value: 100296, category: 'テクノロジーとコンピュータ', label: 'アニメーション', },
  { value: 100297, category: 'テクノロジーとコンピュータ', label: 'ウイルス対策', },
  { value: 100298, category: 'テクノロジーとコンピュータ', label: 'C/C++', },
  { value: 100299, category: 'テクノロジーとコンピュータ', label: 'カメラとビデオカメラ', },
  { value: 100300, category: 'テクノロジーとコンピュータ', label: '携帯電話', },
  { value: 100301, category: 'テクノロジーとコンピュータ', label: 'コンピュータ資格', },
  { value: 100302, category: 'テクノロジーとコンピュータ', label: 'コンピューターネットワーク', },
  { value: 100303, category: 'テクノロジーとコンピュータ', label: 'コンピューター周辺機器', },
  { value: 100304, category: 'テクノロジーとコンピュータ', label: 'コンピュータのレビュー', },
  { value: 100305, category: 'テクノロジーとコンピュータ', label: 'データセンター', },
  { value: 100306, category: 'テクノロジーとコンピュータ', label: 'データベース', },
  { value: 100307, category: 'テクノロジーとコンピュータ', label: 'デスクトップパブリッシング', },
  { value: 100308, category: 'テクノロジーとコンピュータ', label: 'デスクトップビデオ', },
  { value: 100309, category: 'テクノロジーとコンピュータ', label: 'メール', },
  { value: 100310, category: 'テクノロジーとコンピュータ', label: 'グラフィックスソフトウェア', },
  { value: 100311, category: 'テクノロジーとコンピュータ', label: 'ホームビデオ/DVD', },
  { value: 100312, category: 'テクノロジーとコンピュータ', label: 'インターネット技術', },
  { value: 100313, category: 'テクノロジーとコンピュータ', label: 'Java', },
  { value: 100314, category: 'テクノロジーとコンピュータ', label: 'JavaScript', },
  { value: 100315, category: 'テクノロジーとコンピュータ', label: 'マックのサポート', },
  { value: 100316, category: 'テクノロジーとコンピュータ', label: 'MP3/MIDI', },
  { value: 100317, category: 'テクノロジーとコンピュータ', label: 'ネット会議', },
  { value: 100318, category: 'テクノロジーとコンピュータ', label: '初心者のためのネット', },
  { value: 100319, category: 'テクノロジーとコンピュータ', label: 'ネットワークセキュリティー', },
  { value: 100320, category: 'テクノロジーとコンピュータ', label: 'パームトップ/携帯情報端末', },
  { value: 100321, category: 'テクノロジーとコンピュータ', label: 'PCサポート', },
  { value: 100322, category: 'テクノロジーとコンピュータ', label: 'ポータブル', },
  { value: 100323, category: 'テクノロジーとコンピュータ', label: 'エンターテインメント', },
  { value: 100324, category: 'テクノロジーとコンピュータ', label: 'フリーウェア/シェアウェア', },
  { value: 100325, category: 'テクノロジーとコンピュータ', label: 'Unix', },
  { value: 100326, category: 'テクノロジーとコンピュータ', label: 'ビジュアルベーシック', },
  { value: 100327, category: 'テクノロジーとコンピュータ', label: 'Webのクリップアート', },
  { value: 100328, category: 'テクノロジーとコンピュータ', label: 'ウェブデザイン/HTML', },
  { value: 100329, category: 'テクノロジーとコンピュータ', label: 'ウェブ検索', },
  { value: 100330, category: 'テクノロジーとコンピュータ', label: 'ウィンドウズ', },
  { value: 100331, category: '旅行', label: '旅行その他', },
  { value: 100332, category: '旅行', label: '冒険旅行', },
  { value: 100333, category: '旅行', label: 'アフリカ', },
  { value: 100334, category: '旅行', label: '航空旅行', },
  { value: 100335, category: '旅行', label: 'オーストラリアとニュージーランド', },
  { value: 100336, category: '旅行', label: 'ベッドと朝食', },
  { value: 100337, category: '旅行', label: 'バジェット・トラベル', },
  { value: 100338, category: '旅行', label: '出張旅行', },
  { value: 100339, category: '旅行', label: '米国のロケールによって', },
  { value: 100340, category: '旅行', label: 'キャンプ', },
  { value: 100341, category: '旅行', label: 'カナダ', },
  { value: 100342, category: '旅行', label: 'カリブ海', },
  { value: 100343, category: '旅行', label: 'クルーズ', },
  { value: 100344, category: '旅行', label: '東欧', },
  { value: 100345, category: '旅行', label: 'ヨーロッパ', },
  { value: 100346, category: '旅行', label: 'フランス', },
  { value: 100347, category: '旅行', label: 'ギリシャ', },
  { value: 100348, category: '旅行', label: 'ハネムーン/休暇', },
  { value: 100349, category: '旅行', label: 'ホテル', },
  { value: 100350, category: '旅行', label: 'イタリア', },
  { value: 100351, category: '旅行', label: '日本', },
  { value: 100352, category: '旅行', label: 'メキシコと中米', },
  { value: 100353, category: '旅行', label: '国立公園', },
  { value: 100354, category: '旅行', label: '南米', },
  { value: 100355, category: '旅行', label: 'スパ', },
  { value: 100356, category: '旅行', label: 'テーマパーク', },
  { value: 100357, category: '旅行', label: '子供と一緒に旅行', },
  { value: 100358, category: '旅行', label: 'イギリス', },
  { value: 100359, category: '不動産', label: '不動産その他', },
  { value: 100360, category: '不動産', label: 'アパート', },
  { value: 100361, category: '不動産', label: '建築家', },
  { value: 100362, category: '不動産', label: '家の売買', },
  { value: 100363, category: 'ショッピング', label: 'ショッピングその他', },
  { value: 100364, category: 'ショッピング', label: 'コンテストと景品', },
  { value: 100365, category: 'ショッピング', label: 'クーポン', },
  { value: 100366, category: 'ショッピング', label: '比較', },
  { value: 100367, category: 'ショッピング', label: 'エンジン', },
  { value: 100368, category: '宗教とスピリチュアル', label: '宗教とスピリチュアルその他', },
  { value: 100369, category: '宗教とスピリチュアル', label: '代替宗教', },
  { value: 100370, category: '宗教とスピリチュアル', label: '無神論/不可知論', },
  { value: 100371, category: '宗教とスピリチュアル', label: '仏教', },
  { value: 100372, category: '宗教とスピリチュアル', label: 'カトリック', },
  { value: 100373, category: '宗教とスピリチュアル', label: 'キリスト教', },
  { value: 100374, category: '宗教とスピリチュアル', label: 'ヒンドゥー教', },
  { value: 100375, category: '宗教とスピリチュアル', label: 'イスラム教', },
  { value: 100376, category: '宗教とスピリチュアル', label: 'ユダヤ教', },
  { value: 100377, category: '宗教とスピリチュアル', label: '末日聖徒', },
  { value: 100378, category: '宗教とスピリチュアル', label: '異教徒/ウィッカ信者', },
  { value: 100379, category: 'カテゴリ不明', label: 'カテゴリ不明その他', },
  { value: 100380, category: '非標準のコンテンツ', label: '非標準のコンテンツその他', },
  { value: 100381, category: '非標準のコンテンツ', label: '野良コンテンツ', },
  { value: 100382, category: '非標準のコンテンツ', label: '極端な表現/露骨な暴力', },
  { value: 100383, category: '非標準のコンテンツ', label: 'アダルト', },
  { value: 100384, category: '非標準のコンテンツ', label: '卑猥なコンテンツ', },
  { value: 100385, category: '非標準のコンテンツ', label: '悪意のあるコンテンツ', },
  { value: 100386, category: '非標準のコンテンツ', label: '準備中のサイト', },
  { value: 100387, category: '非標準のコンテンツ', label: 'インセンティブ広告', },
  { value: 100388, category: '違法コンテンツ', label: '違法コンテンツその他', },
  { value: 100389, category: '違法コンテンツ', label: '違法コンテンツ', },
  { value: 100390, category: '違法コンテンツ', label: '非合法ソフト', },
  { value: 100391, category: '違法コンテンツ', label: 'スパイウェア/マルウェア', },
  { value: 100392, category: '違法コンテンツ', label: '著作権侵害', },
];
